import { render } from "./Clienti.vue?vue&type=template&id=0ef2dbe8&scoped=true"
import script from "./Clienti.vue?vue&type=script&lang=js"
export * from "./Clienti.vue?vue&type=script&lang=js"

import "./Clienti.vue?vue&type=style&index=0&id=0ef2dbe8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef2dbe8"]])

export default __exports__